module.exports = __webpack_public_path__ + "img/logo.74e70c69.svg";